/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Select,
  Spinner
} from '../'

import {
  decodeBase64
} from '../../utils'

class PayrollCycleSelect extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    employer: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool,
    data: PropTypes.object.isRequired
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    }

    if (this.props.data.error) {
      return <div>Options not loaded</div>
    }

    return (
      <Select
        id={this.props.id || 'payrollCycleSelect'}
        placeholder="Select payroll cycle"
        value={this.props.value}
        options={this.props.data.payrollcycles.edges.map((payrollcycle) => (
          {
            value: payrollcycle.node.id,
            label: payrollcycle.node.name
            //   {` - `}
            //   <SpanWithData forField="PayrollCycleCycle" searchKey={payrollcycle.node.cycle} />
            // </span>
          }
        ))}
        onChange={this.props.onChange}
        hasError={this.props.hasError}
      />
    )
  }
}

const getPayrollCycles = gql`
  query($employer: UUID) {
    payrollcycles(employer_Id: $employer) {
      edges {
        node {
          id
          name
          cycle
        }
      }
    }
  }
`

const withData =
  graphql(getPayrollCycles, {
    options: (ownProps) => ({
      variables: {
        employer: decodeBase64(ownProps.employer)
      }
    })
  })

export default withData(PayrollCycleSelect)



// WEBPACK FOOTER //
// ./src/components/payroll-cycle-select/index.js